export const ADD_EVENT = 'ADD_EVENT'
export const GET_EVENTS = 'GET_EVENTS'
export const SELECT_EVENT = 'SELECT_EVENT';
export const GET_EVENT_BOOKINGS = 'GET_EVENT_BOOKINGS'